import classNames from 'classnames';

import ProductCardSkeleton from '@/components/common/Skeleton/new-product-card';

export default function ItemLineSkeleton() {
  return (
    <div className="my-2.5 overflow-hidden">
      <div className="flex justify-between relative px-5">
        <div className="bg-surface-200-bg inline-block h-6 leading-8 w-24 rounded-sm skeleton" />
        <div className="bg-surface-200-bg inline-block h-6 leading-8 w-20 rounded-700 skeleton" />
      </div>
      <div className="whitespace-nowrap overflow-hidden flex gap-3 pt-0 ml-[6px] mt-[5px]">
        {new Array(3).fill(0).map((_item, index) => {
          return (
            <ProductCardSkeleton
              key={`skeleton-product-list-item-${index}`}
              className={classNames('flex-shrink-0 !w-[313px] ml-1')}
            />
          );
        })}
      </div>
    </div>
  );
}
